import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { getOnboardingCallLink } from '../../../self-upgrade.util';

export const FORMS_PRICE = 199;
export const FORMS_ONBOARDER_SCHEDULING_URL = getOnboardingCallLink(Feature.FORMS);
export const FORMS_SINGLE_ONBOARDER_SCHEDULING_URL =
  'https://getweave.chilipiper.com/round-robin/upsells-digital-forms-single';
export const FORMS_MULTI_ONBOARDER_SCHEDULING_URL =
  'https://getweave.chilipiper.com/round-robin/upsells-digital-forms-multi';
export const FORMS_PAGE_URL = '/forms/submissions/inbox/all';
export const FORMS_VIDEO_URL = 'https://fast.wistia.com/embed/medias/2mcdggqs2z';
